import { api } from "./api";

const BASE = "/site-settings";

function toUi(s) {
  if (!s) return null;
  return {
    primaryPhone: s.primaryPhone || "",
    secondaryPhone: s.secondaryPhone || "",
    whatsappFooter: s.whatsappFooter || "",
    whatsappFloating: s.whatsappFloating || "",
    email: s.email || "",
    hours: s.hours || "",
    address: s.address || "",
    mapEmbedUrl: s.mapEmbedUrl || "",
    instagramUrl: s.instagramUrl || "",
    facebookUrl: s.facebookUrl || "",
    youtubeUrl: s.youtubeUrl || "",
    linkedinUrl: s.linkedinUrl || "",
    twitterUrl: s.twitterUrl || "",
    defaultAdvisorName: s.defaultAdvisorName || "",
    defaultAdvisorInitials: s.defaultAdvisorInitials || "",
    defaultAdvisorRole: s.defaultAdvisorRole || "",
    defaultAdvisorRating: s.defaultAdvisorRating ?? 4.8,
    siteName: s.siteName || "",
    tagline: s.tagline || "",
    reraId: s.reraId || "",
    contactPhoneProperty: s.contactPhoneProperty || "",
    contactPhoneInterior: s.contactPhoneInterior || "",
    // F2/F4: CMS JSON fields
    faqItems: Array.isArray(s.faqItems) ? s.faqItems : [],
    teamFeatured: Array.isArray(s.teamFeatured) ? s.teamFeatured : [],
    heroStats: s.heroStats || null,
    homepageSections: Array.isArray(s.homepageSections) ? s.homepageSections : [],
    updatedAt: s.updatedAt,
  };
}

function toApi(payload) {
  const out = { ...payload };
  delete out.updatedAt;
  if (out.defaultAdvisorRating !== undefined && out.defaultAdvisorRating !== null && out.defaultAdvisorRating !== "") {
    out.defaultAdvisorRating = Number(out.defaultAdvisorRating);
    if (Number.isNaN(out.defaultAdvisorRating)) delete out.defaultAdvisorRating;
  }
  return out;
}

export const siteSettingsApi = {
  async get() {
    const res = await api.get(BASE);
    return toUi(res);
  },
  async update(payload) {
    const res = await api.patch(BASE, toApi(payload));
    return toUi(res);
  },
};
